
//PRODUCTION

export const environment = {
  name: "prod",
  production: true, //means this is a production build, not deployed to production
  isDevMode: false,  //will not show DEV in header
  baseUrl: "https://webapi.gorpms.com", //PROD
  version: "2.4.17.20260323-1400"  // "2.4.16.20260319-1615"
};
